import { createPaginator } from "@smithy/core";
import { ListDatasetLabelsCommand, } from "../commands/ListDatasetLabelsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListDatasetLabels = createPaginator(RekognitionClient, ListDatasetLabelsCommand, "NextToken", "NextToken", "MaxResults");
